import { render, staticRenderFns } from "./EditServiceSideBarTabsRoom.vue?vue&type=template&id=af827234&"
import script from "./EditServiceSideBarTabsRoom.vue?vue&type=script&lang=js&"
export * from "./EditServiceSideBarTabsRoom.vue?vue&type=script&lang=js&"
import style0 from "./EditServiceSideBarTabsRoom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports